import React, { useEffect, useState } from 'react';
import {
  forEach,
  isArray,
  isObject,
  camelCase,
  sortBy,
  isEqual,
  snakeCase,
  isEmpty,
  differenceWith,
  capitalize
} from 'lodash';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  IdentityArr,
  AddressArr,
  PACKAGE_UNIT_INDICATION,
  PACKAGE_UNIT_INDICATION_FACTOR,
  TDS_OPTIONS,
  ADC_TYPES
} from '../utils/commonConstant';
import localStorage from '../api/localStorage';
import { toast } from 'react-toastify';
import AppConstants from '../core-components/AppConstants';
import moment from 'moment';
let checksForExternalCompanies = 3;
export const toCamelCase = (snake_case_object) => {
  var camelCaseObject = {};
  forEach(snake_case_object, function (value, key) {
    if (isArray(value)) {
      value = value.map((v) => {
        return toCamelCase(v);
      });
    } else if (isObject(value)) {
      value = toCamelCase(value);
    }
    camelCaseObject[camelCase(key)] = value;
  });
  return camelCaseObject;
};

export const toCamelCaseTemp = (snake_case_object) => {
  var camelCaseObject = {};
  forEach(snake_case_object, function (value, key) {
    if (isArray(value)) {
      value = value.map((v) => {
        return isObject(v) ? toCamelCaseTemp(v) : v;
      });
    } else if (isObject(value)) {
      value = toCamelCaseTemp(value);
    }
    camelCaseObject[camelCase(key)] = value;
  });
  return camelCaseObject;
};

const restrictedDomainsByProvider = {
  Gmail: [
    'gmail.com',
    'gmail.com.br',
    'gmail.ru',
    'gmail.co.uk',
    'gmail.fr',
    'gmail.de',
    'gmail.co.in'
  ],
  Yahoo: [
    'yaho.com',
    'yahoo.ae',
    'yahoo.at',
    'yahoo.be',
    'yahoo.ca',
    'yahoo.ch',
    'yahoo.cn',
    'yahoo.co',
    'yahoo.co.id',
    'yahoo.co.il',
    'yahoo.co.in',
    'yahoo.co.jp',
    'yahoo.co.kr',
    'yahoo.co.nz',
    'yahoo.co.th',
    'yahoo.co.uk',
    'yahoo.co.za',
    'yahoo.com',
    'yahoo.com.ar',
    'yahoo.com.au',
    'yahoo.com.br',
    'yahoo.com.cn',
    'yahoo.com.co',
    'yahoo.com.hk',
    'yahoo.com.is',
    'yahoo.com.mx',
    'yahoo.com.my',
    'yahoo.com.ph',
    'yahoo.com.ru',
    'yahoo.com.sg',
    'yahoo.com.tr',
    'yahoo.com.tw',
    'yahoo.com.vn',
    'yahoo.cz',
    'yahoo.de',
    'yahoo.dk',
    'yahoo.es',
    'yahoo.fi',
    'yahoo.fr',
    'yahoo.gr',
    'yahoo.hu',
    'yahoo.ie',
    'yahoo.in',
    'yahoo.it',
    'yahoo.jp',
    'yahoo.nl',
    'yahoo.no',
    'yahoo.pl',
    'yahoo.pt',
    'yahoo.ro',
    'yahoo.ru',
    'yahoo.se',
    'yahoofs.com'
  ],
  Outlook: [
    'outlook.at',
    'outlook.be',
    'outlook.cl',
    'outlook.co.id',
    'outlook.co.il',
    'outlook.co.nz',
    'outlook.co.th',
    'outlook.com',
    'outlook.com.au',
    'outlook.com.br',
    'outlook.com.gr',
    'outlook.com.pe',
    'outlook.com.tr',
    'outlook.com.vn',
    'outlook.cz',
    'outlook.de',
    'outlook.dk',
    'outlook.es',
    'outlook.fr',
    'outlook.hu',
    'outlook.ie',
    'outlook.in',
    'outlook.it',
    'outlook.jp',
    'outlook.kr',
    'outlook.lv',
    'outlook.my',
    'outlook.nl',
    'outlook.ph',
    'outlook.pt',
    'outlook.sa',
    'outlook.sg',
    'outlook.sk'
  ],
  Hotmail: [
    'hotmail.ca',
    'hotmail.ch',
    'hotmail.co',
    'hotmail.co.il',
    'hotmail.co.jp',
    'hotmail.co.nz',
    'hotmail.co.uk',
    'hotmail.co.za',
    'hotmail.com',
    'hotmail.com.ar',
    'hotmail.com.au',
    'hotmail.com.br',
    'hotmail.com.tr',
    'hotmail.de',
    'hotmail.es',
    'hotmail.fi',
    'hotmail.fr',
    'hotmail.it',
    'hotmail.kg',
    'hotmail.kz',
    'hotmail.nl',
    'hotmail.ru',
    'hotmail.se'
  ],
  Rediff: ['rediff.com', 'rediffmail.com', 'rediffmailpro.com']
};

export const validateEmail = (email) => {
  const domain = email?.split('@')[1]?.toLowerCase();
  const getRestrictedEmailDomains = () => {
    return Object.values(restrictedDomainsByProvider).flat();
  };
  return getRestrictedEmailDomains().includes(domain);
};

export const toSnakeCase = (camel_case_object) => {
  var snakeCaseObject = {};
  forEach(camel_case_object, function (value, key) {
    if (isArray(value)) {
      value = value.map((v) => {
        return isObject(v) ? toSnakeCase(v) : v;
      });
    } else if (isObject(value)) {
      value = toSnakeCase(value);
    }
    snakeCaseObject[snakeCase(key)] = value;
  });
  return snakeCaseObject;
};

export const getErrorMessage = (error) => {
  console.error('Error : ', error);
  if (error?.response?.data || error?.data || (error?.errors && error?.errors?.length)) {
    const errorObject =
      (error?.data && error?.data?.errorMessage) ||
      error?.response?.data?.message ||
      error?.response?.data?.errorMsg ||
      (Array.isArray(error?.response?.data?.errors) &&
        error?.response?.data?.errors?.length &&
        error?.response?.data?.errors[0]?.msg) ||
      error?.response?.data?.msg ||
      error?.response?.data ||
      error?.errors[0]?.msg ||
      'Something went wrong.';

    switch (typeof errorObject) {
      case 'object':
        return (
          errorObject?.msg ||
          JSON.stringify(errorObject.msg) ||
          errorObject?.data?.msg ||
          errorObject?.resp?.msg
        );
      case 'string':
        return errorObject;
      default:
        return 'Something went wrong.';
    }
  } else {
    if (typeof error === 'string') {
      return error;
    }
    return 'Something went wrong.';
  }
};

// Prevent duplicate error toasts

export const getMessageIdForToast = (message) => {
  if (message) return message.replace(/ +/g, '_').toLowerCase();
  return '';
};

export const errToastMessage = (err) => {
  const message = getErrorMessage(err);

  if (message) {
    const id = getMessageIdForToast(message);
    toast.error(message, { toastId: id });
  }
};

export const parseCompanyServices = (services) => {
  return sortBy(services, (service) => service.serviceId)
    .filter(
      (service) =>
        service.service &&
        service.service.status &&
        parseInt(service.service.status) !== parseInt(checksForExternalCompanies)
    )
    .map((service) => {
      if (service.serviceId === 1) {
        return {
          id: service.serviceId,
          name: service.companyServiceName,
          identities: service.identities,
          isSelected: service.defaultService === 1 ? true : false
        };
      } else {
        return {
          id: service.serviceId,
          name: service.companyServiceName,
          isSelected: service.defaultService === 1 ? true : false
        };
      }
    });
};

/**
 * Validates phone number
 * case 1: if input given contains intl number(eg:+15417543010),checks for validity
 * case 2: if local string(eg:9892782982) is given parses the number with default code(i.e india) and checks validity
 * @param   {string} phoneNumber
 * @return  {boolean}
 */
export const isValidPhoneNumber = (value) => {
  const regexForTenDigit = /^[6-9]{1}[0-9]{9}/;
  const regexForAllowedCharacter = /^[0-9+]+$/;
  try {
    let parsedPhone = null;
    let country;
    let phone = value.toString();

    // Numbers without country codes ( assuming indian numbers )
    if (phone[0] !== '+' && Number.isInteger(parseInt(phone[0], 10))) {
      if (phone.length === 10 && phone.match(regexForTenDigit)) {
        phone = `+91${phone}`;
      } else if (phone[0] === '0' && phone.slice(1).match(regexForTenDigit)) {
        phone = `+91${phone.slice(1)}`;
      } else {
        return false;
      }
    }
    if (phone.slice(0, 3) === '+91') {
      // library was allowing indian numbers with less than 10 digits
      if (!phone.slice(3).match(regexForTenDigit)) {
        return false;
      }
      country = 'IN';
    }

    if (!phone.match(regexForAllowedCharacter)) {
      return false;
    }
    // parse number ( parses numbers in specific formats also e.g. (+91) 123 456 7890 )
    // also parses numbers with different country codes
    parsedPhone = parsePhoneNumberFromString(phone, country);

    // validate the parsed number
    if (parsedPhone == undefined || (parsedPhone && !parsedPhone.isValid())) {
      return false;
    }

    return true;
  } catch (err) {
    // try catch block was required because parsePhoneNumber throws an error if number is invalid
    return false;
  }
};

// This function return boolen value by validating trimmed  phone number with country code
export const isTrimmedPhoneValid = (countryCode, phone, setFieldValue, fieldName) => {
  const trimmedVal = getTrimmedValue(phone, false);
  const IntlNumber = `${countryCode + '' + trimmedVal}`;
  if (!isValidPhoneNumber(IntlNumber)) {
    setFieldValue(fieldName, false);
  } else {
    setFieldValue(fieldName, true);
  }
  if (!trimmedVal) {
    setFieldValue(fieldName, true);
  }
};
/**
 * Returns proper international phonenumber
 * case 1: if input given contains intl number(eg:+15417543010),checks for validity
 * case 2: if local string(eg:9892782982) is given parses the number with default code(i.e india) and checks validity
 * @param   {string} phoneNumber
 * @return  {string} intlphoneNumber
 */
export const getIntlPhoneNumber = (phoneNumber) => {
  var intlphoneNumber = phoneNumber;
  var numberObj = null;
  if (phoneNumber?.length > 10) {
    //when number contains countrycode but not E164 number format
    if (!phoneNumber.startsWith('+')) {
      phoneNumber = `+${phoneNumber}`;
    }
    numberObj = parsePhoneNumberFromString(phoneNumber);
  } else {
    //adding 'IN' as code if country code is present
    numberObj = parsePhoneNumberFromString(phoneNumber, 'IN');
  }
  if (numberObj) {
    intlphoneNumber = numberObj.number;
  }

  return intlphoneNumber;
};
/**
 * Returns a number obj
 * case 1: if input given contains intl number(eg:+15417543010),checks for validity
 * case 2: if local string(eg:9892782982) is given parses the number with default code(i.e india) and checks validity
 * @param   {string} phoneNumber
 * @return  {object} numberObj
 */
export const getIntlPhoneNumberObject = (phoneNumber, countryCode = '') => {
  var numberObj = null;

  if (phoneNumber.length > 10) {
    //when number contains countrycode but not E164 number format
    if (!phoneNumber.startsWith('+') && !countryCode) {
      phoneNumber = `+${phoneNumber}`;
    } else {
      phoneNumber = `${countryCode}${phoneNumber}`;
    }
    numberObj = parsePhoneNumberFromString(phoneNumber);
  } else if (phoneNumber.length === 10 && !countryCode) {
    // When there is no country code and phone number length is 10 adding default +91 country code
    numberObj = getIntlPhoneNumberObjectWithCountryCode(phoneNumber, '+91');
  } else {
    //adding 'IN' as code if country code is present
    numberObj = getIntlPhoneNumberObjectWithCountryCode(phoneNumber, countryCode);
  }
  return numberObj;
};

export const getIntlPhoneNumberObjectWithCountryCode = (phoneNumber, countryCode) => {
  var numberObj = null;
  phoneNumber = `${countryCode + phoneNumber}`;
  numberObj =
    parsePhoneNumberFromString(phoneNumber) || parsePhoneNumberFromString(phoneNumber, countryCode);
  return numberObj;
};

export const compareObjects = (obj1, obj2) => isEqual(obj1, obj2);

//jwt parser to fetch candidate id in BGV
export const jwtParser = (token) => {
  try {
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  } catch (e) {
    return null;
  }
};

/**
 * Returns a total any count
 * @param   {array} values
 * @return  {integer}
 */
export const getAnyCount = (values = []) => {
  let count = 0,
    str = values.filter((val) => {
      if (val && val.match(/ANY_/g)) return val;
    });
  count = str && str[0] ? str[0].split('_')[1] || 0 : 0;
  return parseInt(count);
}; //end of getAnyCount

export const getAnyCountAddressCourt = (values = []) => {
  let count = 0,
    str = values.filter((val) => {
      if (val?.type.match(/ANY_/g)) return val;
    });
  count = str && str[0] ? str[0]?.type?.split('_')[1] || 0 : 0;
  return parseInt(count);
}; //end of getAnyCountAddressCourt

/**
 * Returns a check count
 * @param   {array} values
 * @return  {integer}
 */
export const getTotalAnyCount = (values = []) => {
  let count = 0,
    totalCount = 0,
    str = values.filter((val) => {
      if (val && val.match(/ANY_/g)) return val;
    });
  count = str && str[0] ? str[0].split('_')[1] : 0;
  if (count) {
    totalCount = values.length - 1 + parseInt(count);
  } else {
    totalCount = values.length;
  }
  return parseInt(totalCount);
}; //end of getTotalAnyCount

/**
 * Returns a package is cutomizable or not
 * @param   {object} config
 * @return  {boolean}
 */
export const isCustomisable = (config = {}) => {
  if (
    config.reference &&
    (config.referenceType === 'SPECIFIC' || config.referenceType === 'TOTAL')
  ) {
    return true;
  }
  if (config.identity && config.identity.length && getAnyCount(config.identity)) {
    return true;
  }
  if (
    (config.address &&
      config.address.length === 1 &&
      getAnyCountAddressCourt(config.address) === 1) ||
    (config.court && config.court.length === 1 && getAnyCountAddressCourt(config.court) === 1)
  ) {
    return true;
  }
}; //end of isCustomisable

// Return total count of array of integer
export const getCount = (arr = []) => {
  const count = arr.reduce((acc, item) => {
    return acc + parseInt(item);
  }, 0);

  return count;
};

export const getFilteredChecks = (checks = [], type = '') => {
  let strArr = [];
  const isAnyExist = checks.join(',').match(/ANY_/g) ? true : false;
  const isAllId = checks.includes('ALL');
  if (checks.length && isAnyExist && type) {
    if (type.toLowerCase() === 'identity') {
      strArr = Object.values(IdentityArr).filter((item) => {
        return !checks.includes(item);
      });
    } else if (type.toLowerCase() === 'address' || type.toLowerCase() === 'court') {
      strArr = Object.keys(AddressArr).filter((item) => {
        return !checks.includes(item);
      });
    }

    return strArr;
  } else if (isAllId) {
    strArr = Object.values(IdentityArr).filter((item) => {
      return item;
    });
    return strArr;
  } else {
    return null;
  }
};

export const isMobileTablet = () => {
  var check = false;

  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);

  return check;
};

export const showAddOnLabel = (addon) => {
  const addOnCases = {
    address: addon['address'].length,
    cibil: addon['cibil'].cost,
    court: addon['court'].length,
    custom: addon['custom'].length,
    drug: addon['drug'].length,
    education: addon['education']?.cost || addon['education']?.config?.length,
    employment: addon['employment'].cost,
    identity: addon['identity'].length,
    reference: addon['reference'].length,
    world: addon['world'].cost,
    socialMedia:
      addon['socialMedia'].length &&
      addon['socialMedia']?.some((socialMedia) => socialMedia.config?.length > 0)
  };

  for (let check in addon) {
    if (addOnCases[check]) {
      return true;
    }
  }
  return false;
};
export const getCustomCheckSVG = (
  color = '#999999',
  width = '35px',
  height = '18px',
  cursor = 'default'
) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill={'none'}
      style={{ display: 'inline-block', verticalAlign: 'middle', cursor: cursor }}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M15.1254 7.21425C15.0941 6.92665 14.9578 6.66073 14.7424 6.46755C14.5271 6.27436 14.248 6.16754 13.9587 6.16758H13.5387C13.4536 5.89611 13.3349 5.63633 13.1854 5.39425L13.5054 5.06758C13.7111 4.86311 13.8332 4.58935 13.848 4.2997C13.8628 4.01005 13.7692 3.72528 13.5854 3.50092C13.2598 3.09535 12.8909 2.72651 12.4854 2.40092C12.2599 2.21668 11.9741 2.12283 11.6833 2.13761C11.3925 2.1524 11.1176 2.27476 10.912 2.48092L10.6254 2.78758C10.3763 2.65084 10.1093 2.54985 9.83204 2.48758V2.04092C9.83359 1.75297 9.72798 1.47474 9.53576 1.26034C9.34354 1.04594 9.07845 0.910701 8.79204 0.880918C8.26708 0.820944 7.737 0.820944 7.21204 0.880918C6.92444 0.909149 6.65772 1.04372 6.46413 1.25828C6.27053 1.47284 6.16399 1.75193 6.16538 2.04092V2.46092C5.89341 2.54479 5.63347 2.66355 5.39204 2.81425L5.07204 2.49425C4.86646 2.28809 4.59157 2.16573 4.3008 2.15095C4.01003 2.13616 3.72414 2.23001 3.49871 2.41425C3.09781 2.74058 2.73346 3.1094 2.41204 3.51425C2.22826 3.73861 2.13463 4.02339 2.14943 4.31304C2.16422 4.60269 2.28636 4.87644 2.49204 5.08092L2.79871 5.37425C2.6641 5.62428 2.56322 5.89105 2.49871 6.16758H2.03871C1.74942 6.16754 1.47031 6.27436 1.25498 6.46755C1.03965 6.66073 0.903273 6.92665 0.872043 7.21425C0.818694 7.73734 0.818694 8.2645 0.872043 8.78758C0.903273 9.07518 1.03965 9.34111 1.25498 9.53429C1.47031 9.72747 1.74942 9.8343 2.03871 9.83425H2.45871C2.54517 10.1052 2.66379 10.3648 2.81204 10.6076L2.49204 10.9343C2.28636 11.1387 2.16422 11.4125 2.14943 11.7021C2.13463 11.9918 2.22826 12.2766 2.41204 12.5009C2.73763 12.9065 3.10648 13.2753 3.51204 13.6009C3.73748 13.7852 4.02336 13.879 4.31413 13.8642C4.6049 13.8494 4.87979 13.7271 5.08538 13.5209L5.37204 13.2143C5.6211 13.351 5.88816 13.452 6.16538 13.5143V13.9743C6.16383 14.2622 6.26944 14.5404 6.46166 14.7548C6.65388 14.9692 6.91897 15.1045 7.20538 15.1343C7.46857 15.1666 7.73354 15.1822 7.99871 15.1809C8.26166 15.1824 8.52444 15.1668 8.78538 15.1343C9.07298 15.106 9.3397 14.9715 9.53329 14.7569C9.72689 14.5423 9.83343 14.2632 9.83204 13.9743V13.5543C10.104 13.4704 10.3639 13.3516 10.6054 13.2009L10.9254 13.5209C11.131 13.7271 11.4059 13.8494 11.6966 13.8642C11.9874 13.879 12.2733 13.7852 12.4987 13.6009C12.9059 13.2771 13.2749 12.9081 13.5987 12.5009C13.7819 12.2767 13.8758 11.9927 13.8623 11.7035C13.8487 11.4143 13.7287 11.1403 13.5254 10.9343L13.212 10.6409C13.3488 10.3919 13.4498 10.1248 13.512 9.84758H13.972C14.2613 9.84763 14.5404 9.74081 14.7558 9.54762C14.9711 9.35444 15.1075 9.08852 15.1387 8.80092C15.1921 8.27783 15.1921 7.75067 15.1387 7.22758L15.1254 7.21425ZM10.6654 10.5009H7.16538V11.0009C7.16538 11.1335 7.1127 11.2607 7.01893 11.3545C6.92516 11.4482 6.79798 11.5009 6.66538 11.5009C6.53277 11.5009 6.40559 11.4482 6.31182 11.3545C6.21805 11.2607 6.16538 11.1335 6.16538 11.0009V10.5009H5.33204C5.19943 10.5009 5.07226 10.4482 4.97849 10.3545C4.88472 10.2607 4.83204 10.1335 4.83204 10.0009C4.83204 9.86831 4.88472 9.74113 4.97849 9.64736C5.07226 9.5536 5.19943 9.50092 5.33204 9.50092H6.16538V9.00092C6.16538 8.86831 6.21805 8.74113 6.31182 8.64736C6.40559 8.5536 6.53277 8.50092 6.66538 8.50092C6.79798 8.50092 6.92516 8.5536 7.01893 8.64736C7.1127 8.74113 7.16538 8.86831 7.16538 9.00092V9.50092H10.6654C10.798 9.50092 10.9252 9.5536 11.0189 9.64736C11.1127 9.74113 11.1654 9.86831 11.1654 10.0009C11.1654 10.1335 11.1127 10.2607 11.0189 10.3545C10.9252 10.4482 10.798 10.5009 10.6654 10.5009ZM10.6654 6.50092H9.83204V7.00092C9.83204 7.13353 9.77936 7.2607 9.6856 7.35447C9.59183 7.44824 9.46465 7.50092 9.33204 7.50092C9.19943 7.50092 9.07226 7.44824 8.97849 7.35447C8.88472 7.2607 8.83204 7.13353 8.83204 7.00092V6.50092H5.33204C5.19943 6.50092 5.07226 6.44824 4.97849 6.35447C4.88472 6.2607 4.83204 6.13353 4.83204 6.00092C4.83204 5.86831 4.88472 5.74113 4.97849 5.64736C5.07226 5.5536 5.19943 5.50092 5.33204 5.50092H8.83204V5.00092C8.83204 4.86831 8.88472 4.74113 8.97849 4.64736C9.07226 4.5536 9.19943 4.50092 9.33204 4.50092C9.46465 4.50092 9.59183 4.5536 9.6856 4.64736C9.77936 4.74113 9.83204 4.86831 9.83204 5.00092V5.50092H10.6654C10.798 5.50092 10.9252 5.5536 11.0189 5.64736C11.1127 5.74113 11.1654 5.86831 11.1654 6.00092C11.1654 6.13353 11.1127 6.2607 11.0189 6.35447C10.9252 6.44824 10.798 6.50092 10.6654 6.50092Z'
        fill={color}
      />
    </svg>
  );
};

export const getIDCheck = (check) => {
  if (check === 1) {
    return 'ANY';
  } else if (check === 2) {
    return 'PAN';
  } else if (check === 3) {
    return 'Driving License';
  } else if (check === 4) {
    return 'Passport';
  } else if (check === 5) {
    return 'Voter ID';
  } else if (check === 6) {
    return 'Aadhaar';
  }
};
export const getStatus = (status) => {
  if (status === null || status === '') {
    status = 15;
  } else if (status === -1) {
    status = 13;
  } else if (status === -2) {
    status = 14;
  } else if (status === 13) {
    // When the status is 13 for inconclusive map it to the last element of status array
    status = 16;
  }
  return parseInt(status);
};

export const getIdentityAnyCounter = (identity = []) => {
  let count = 0;
  const str = identity.find((item) => item.includes('ANY_'));
  count = str && str.substr(str.length - 1);
  return count ? parseInt(count) : 0;
};

export const getTotalCheckCount = (checks = []) => {
  let total = checks.length;
  let anyCount = getIdentityAnyCounter(checks);
  if (anyCount) {
    total = total + anyCount - 1;
  }
  return parseInt(total);
};

// Filter object by key
export const filterObjectByKeyCaseInsensitive = (obj, filterKey = '', exactMatch = false) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => {
      if (exactMatch) {
        return key.toLowerCase() == filterKey.toLowerCase();
      } else {
        return key.toLowerCase().includes(filterKey.toLowerCase());
      }
    })
  );
};

export const getPackageType = () => {
  const token = localStorage.getToken();
  const parsedJwtDetail = jwtParser(token);
  return parsedJwtDetail?.data?.modelType || '';
};

export function useDebounce(value, delay) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}

// calculate TDS for company
export const calculateTDS = (amount, companyTds) => {
  return amount > 0 ? parseFloat(parseFloat(amount * (companyTds / 100)).toFixed(2)) : 0;
};
// calculate Tax for company
export const calculateTax = (amount, companyTax) => {
  return parseFloat(parseFloat(amount * (companyTax / 100)).toFixed(2)) || 0;
};

/**
 *  TDS otpion based on config from SA side
 *  case 1 : TDS selected as both = then all three option will come [None,2%,10%]
 *  case 2 : TDS selected as 2% = then [None,2%] options will come
 *  case 3 : TDS selected as 10% = then [None,10%] options will come
 */
export const getTdsOptions = (value, disableOption = false) => {
  const options = [...TDS_OPTIONS];
  if (value === 'BOTH') {
    return disableTdsOptions(options, disableOption);
  } else if (value === '2') {
    return disableTdsOptions(
      options.filter((opt) => opt.value != 10),
      disableOption
    );
  } else if (value === '10') {
    return disableTdsOptions(
      options.filter((opt) => opt.value != 2),
      disableOption
    );
  }
};

// this funtion is used to disable TDS radio options other NONE option, if "Use credit balance" checkbox selected
export const disableTdsOptions = (options, disableOption) => {
  options.forEach((opt) => {
    opt.disable = disableOption && opt.value != 'NONE' ? true : false;
  });
  return options;
};

/**
 *  return intial tds value for radio options based on SA side config
 */
export const getCompanyTds = (tdsValue) => {
  return tdsValue === 'BOTH'
    ? 'NONE'
    : tdsValue === '2'
    ? '2'
    : tdsValue === '10'
    ? '10'
    : tdsValue === 'NONE'
    ? 'NONE'
    : 'NONE';
};
export const getPackageUnitIndication = (
  lowestUnit,
  packageBalance,
  candidateCount = 0,
  packageType
) => {
  const indicationRange = Math.floor(
    Number.parseFloat(lowestUnit * PACKAGE_UNIT_INDICATION_FACTOR)
  );
  const packageUnitBalanceAfterCandidateAddition = packageBalance - candidateCount;

  if (
    (packageBalance === 0 || packageUnitBalanceAfterCandidateAddition < 0) &&
    packageType !== 'POSTPAID'
  ) {
    return PACKAGE_UNIT_INDICATION.NILL;
  } else if (
    indicationRange >= packageBalance ||
    packageUnitBalanceAfterCandidateAddition <= indicationRange
  ) {
    return PACKAGE_UNIT_INDICATION.LOW;
  } else {
    return PACKAGE_UNIT_INDICATION.SUFFICIENT;
  }
};

// to add commos to value as per Indian Numeration
export const convertToIndianNumeration = (value, decimal) => {
  if (value) {
    value = value.toFixed(2);
  }
  return value
    ? parseFloat(value).toLocaleString('en-IN', { minimumFractionDigits: decimal ? decimal : 0 })
    : 0;
};

export const indianNumerationValue = (value, decimal) => {
  if (value) {
    value = value.toFixed(2);
  }

  return (
    <>
      &#8377;
      {value
        ? parseFloat(value).toLocaleString('en-IN', {
            minimumFractionDigits: decimal ? decimal : 0
          })
        : 0}
    </>
  );
};

export const hasDot = (value) => {
  value = value && value.toString();

  return value && value.includes('.');
};

export const copyToClipboard = (text) => {
  const type = 'text/plain';
  const blob = new Blob([text], { type });
  if (!navigator?.clipboard?.write) {
    // Clipboard API not supported in this browser
    errToastMessage('Clipboard API is not supported in this browser!');
    return;
  }
  const data = [new ClipboardItem({ [type]: blob })];
  try {
    navigator?.clipboard.write(data).then(() => {
      toast.info('Copied to Clipboard!');
    });
  } catch (error) {
    errToastMessage('Copying was unsuccessful!');
  }
};

export const checkForLeadingOrTrailingWhiteSpace = (value) => {
  const length = value?.length;

  if (length) {
    return value[0] === ' ' || value[length - 1] == ' ';
  }
  return false;
};

export const getTrimmedValue = (value, withSpace) => {
  if (value) {
    return withSpace ? value.trim().replace(/\s\s+/g, ' ') : value.trim().replace(/\s+/g, '');
  } else {
    return '';
  }
};

// Using this function will retain the new lines in the text
export const getTrimmedValueWithNewLines = (value, withSpace) => {
  if (value) {
    if (withSpace) {
      return value
        .replace(/^[ \t]+|[ \t]+$/gm, '')
        .replace(/\n[ \t]+/g, '\n')
        .replace(/[ \t]+/g, ' ')
        .split('\n')
        .filter((line) => line.trim() !== '')
        .join('\n');
    } else {
      return value.replace(/^[ \t]+|[ \t]+$/gm, '');
    }
  } else {
    return '';
  }
};

// export const getTrimmedValueWithSpace = (value) => getTrimmedValue(value, true);

// export const getTrimmedValueWithNoSpace = (value) => getTrimmedValue(value, false);
export const getFileHeader = (header) => {
  let fileType = '';
  switch (header) {
    case '89504e47':
      fileType = 'image/png';
      break;
    case 'ffd8ffe0':
    case 'ffd8ffe1':
    case 'ffd8ffe2':
    case 'ffd8ffe3':
    case 'ffd8ffe8':
      fileType = 'image/jpeg';
      break;
    case '25504446':
      fileType = 'application/pdf';
      break;
    default: // Or you can use the blob.fileType as fallback
      fileType = 'unknown';
      break;
  }
  return fileType;
};
export const validateImage = (fileArr, fileType) => {
  let errMessage = '';
  let extensionArr = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/heic'];
  const size = parseInt(fileArr.size / 1024);
  const extension = fileType;
  if (size < AppConstants.fileSize && extension !== 'application/pdf') {
    errMessage = 'FILE_SIZE_EXCEEDS';
  } else if (!extensionArr.includes(extension)) {
    errMessage = 'FILE_TYPE_MISMATCH';
  }
  return errMessage;
};

export const FileErrorMeaage = {
  FILE_SIZE_EXCEEDS:
    'Upload failed. Please upload a file that exceeds ' + AppConstants.fileSize + 'KB',
  FILE_TYPE_MISMATCH: 'Upload failed. File format not valid.'
};

export const getDescription = (usage) => {
  const checkType =
    usage?.checkType === 'CIBIL'
      ? 'Credit Check'
      : usage?.checkType === 'SOCIAL_MEDIA'
      ? usage?.checkType.split('_').join(' ')
      : usage?.checkType ?? '';

  switch (usage.event) {
    case 'CREDIT_NOTE':
      const detailsInvoice = usage?.invoiceDetails;
      let text = '';
      if (detailsInvoice) {
        const invoiceDate = moment(detailsInvoice?.invoiceDate).format('DD-MM-YYYY');
        text = `(Inv No. ${detailsInvoice?.invoiceNumber || ''} : ${invoiceDate})`;
      }
      return `Credit Note ${text}`;
    case 'PACKAGE_BOUGHT':
      return `${usage.packageDetails?.name}`;
    case 'ADDON_BOUGHT':
      return `${checkType}`;
    case 'ADDITIONAL_CHARGE':
      return `${ADC_TYPES[usage?.paymentsCompanyAdditionalCharge?.chargeType]}: ${
        checkType || 'N/A'
      }`;
    case 'ADDITIONAL_CHARGE_REFUND':
      return `${ADC_TYPES[usage?.paymentsCompanyAdditionalCharge?.chargeType]}: ${
        checkType || 'N/A'
      }`;
    case 'CHECK_REFUND':
      return `${checkType}`;
    case 'PACKAGE_UNITS_CONVERTED_TO_CREDITS':
      return `${usage.packageDetails?.name}`;
    case 'CHECK_VERIFICATION_TYPE_CONVERSION':
      return `${usage.checkType}`;
    default:
    case 'CREDITS_LOCKED':
    case 'CREDITS_UNLOCKED':
      return usage?.prepaidInvoiceDetails?.proformaNumber ? (
        <a
          href={`${AppConstants.baseURL}proforma-invoice?invoiceId=${usage?.prepaidInvoiceDetails?.proformaNumber}`}
          target='_blank'
          style={{
            color: '#2755fe'
          }}
        >
          {usage?.prepaidInvoiceDetails?.proformaNumber}
        </a>
      ) : (
        '-'
      );
    case 'ALUMNI_VERIFICATION_BONUS':
      return 'Credits Earned';
  }
};

export const hasPaymentGatewayMethod = (transactions) => {
  if (Array.isArray(transactions)) {
    return transactions.some((transaction) => transaction.method === 'PAYMENT_GATEWAY');
  } else if (typeof transactions === 'object') {
    return transactions.method === 'PAYMENT_GATEWAY';
  }
  return false;
};

export const getPassportIdValidity = (value) => {
  let spaceIndex = -1;
  if (!value) {
    return {
      error: true,
      msg: 'Passport number is required.'
    };
  } else if (value) {
    spaceIndex = value.indexOf(' ');
    if (spaceIndex >= 0 || !value.match('^[a-zA-Z0-9-]+$')) {
      return {
        error: true,
        msg: 'Please enter valid Passport number'
      };
    } else {
      return {
        error: false,
        msg: ''
      };
    }
  }
};

// Covert to comma separated string
export const convertToCommaSeparateString = (value) => {
  if (value) {
    return parseInt(value.replace(/,/g, '')).toLocaleString('en-IN');
  } else {
    return '';
  }
};

export const getCityValue = (data) => {
  if (!isEmpty(data) && data.endsWith('*')) {
    return data.slice(0, -1);
  }
  return data;
};

export const removeAsterisksFromString = (param) => {
  return !isEmpty(param) ? param.replace(/\*/g, '') : '';
};

// Covert to Object to Query string
export const covertObjToQueryString = (obj) => {
  if (obj && typeof obj === 'object') {
    return Object.keys(obj)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
  } else {
    return '';
  }
};

// Covert Query string to Object
export const covertQueryStringToObject = (queryString) => {
  const params = new URLSearchParams(queryString);
  const result = {};
  for (const [key, value] of params) {
    result[key] = result.hasOwnProperty(key)
      ? Array.isArray(result[key])
        ? [...result[key], value]
        : [result[key], value]
      : value;
  }
  return result;
};

export const getPlaceHolderTextForBgvCityDropDown = (cities) => {
  return !isEmpty(cities) ? 'Select' : 'Select or type city name';
};
export const getCourtVerificationType = (type) => {
  switch (type) {
    case 'STANDARD':
      return 'Standard';
    case 'STANDARD_LETTERHEAD':
      return 'Standard (Letterhead)';
    default:
      return '-';
  }
};
export const getAddressVerificationType = (type) => {
  switch (type) {
    case 'PHYSICAL':
      return 'Physical';
    case 'DIGITAL':
      return 'Digital';
    case 'POSTAL':
      return 'Postal';
    default:
      return '-';
  }
};

export const validateCategoriesAndTags = (
  values = {},
  categoriesList = [],
  tagsList = [],
  showToastError = false
) => {
  const {
    category_id: selectedCategoryId,
    category_name: selectedCategoryName,
    tags: selectedTags
  } = values;
  const errors = {};

  if (selectedCategoryId) {
    const isCategoryAvailable = categoriesList.some((cat) => cat.id === selectedCategoryId);
    if (!isCategoryAvailable) {
      errors[
        'categoryError'
      ] = `Category "<span class='text-capitalize font-weight-bold'>${selectedCategoryName}</span>" is deleted. Please create or choose a different category.`;
      errors['deletedCategoryId'] = selectedCategoryId;
    }
  }

  if (selectedTags) {
    const comparator = (a, b) => a.id === b.id;
    const deletedTags = differenceWith(selectedTags, tagsList, comparator);
    if (deletedTags.length > 0) {
      const deletedTagNames = deletedTags.map((t) => t.category);
      const deletedItemsCount = deletedTagNames.length;
      const errorMessage = `Tag${
        deletedItemsCount >= 2 ? 's' : ''
      } <span class='text-capitalize font-weight-bold'>"${deletedTagNames.join(', ')}"</span> ${
        deletedItemsCount >= 2 ? 'are' : 'is'
      } deleted. Please create or choose a different tag${deletedItemsCount >= 2 ? 's' : ''}.`;
      errors['tagsError'] = errorMessage;
      errors['deletedTags'] = deletedTags;
    }
  }
  if (showToastError && !isEmpty(errors)) {
    toast.error(
      <>
        {errors.categoryError && (
          <div dangerouslySetInnerHTML={{ __html: errors.categoryError }}></div>
        )}
        {errors.tagsError && <div dangerouslySetInnerHTML={{ __html: errors.tagsError }}></div>}
      </>
    );
  }
  return errors;
};

export const toCamelCaseWithSpaces = (inputString) => {
  return inputString
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) => {
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    })
    .replace(/\s+/g, '');
};

//Used to get the Tat value(Turn around value) for Reference
//Used for Insufficiency time and effective time

export const tatDataFormatted = (tatDataValue, verificationInfo, key, targetIndex) => {
  let currentIndex = 0;
  for (const info of verificationInfo) {
    const matchedTatData = tatDataValue.find((tatData) => tatData.checkId === info.id);
    if (matchedTatData) {
      if (currentIndex === targetIndex) {
        return matchedTatData[key];
      }
      currentIndex++;
    }
  }
  return null;
};

export const redirectToPreviousPathAfterLogin = (history) => {
  const pathName = window.location.pathname;
  const lastPathname = window.localStorage.getItem('last-redirect-pathname') || '/dashboard';
  const lastPathnameV1 = window.localStorage.getItem('last-redirect-pathname-v1');
  if (!pathName.includes('v1') && !lastPathnameV1) {
    history?.push(lastPathname);
  } else {
    window.localStorage.removeItem('last-redirect-pathname-v1');
    setTimeout(() => {
      window.location.href = lastPathnameV1 || '/dashboard';
    }, 500);
  }
  window.localStorage.removeItem('last-redirect-pathname');
};
/**
 * Get the banners based on the conditions
 * @param {Object} paymentDetails Payment Details API Data
 * @param {Object} upsellRecommendationData Upsell Recommendation Data
 * @returns {Array} Array of Banners
 */
export const getBanners = ({ paymentDetails = {}, upsellRecommendationData = {} }) => {
  const isUpsellRecommendationsPaused = upsellRecommendationData?.isUpsellRecommendationsPaused;
  const isUpsellDataPresent = upsellRecommendationData?.checks?.length > 0;

  // const isReferralEnabled = paymentDetails?.isReferralEnabled;
  // const isConnectModelPaused = paymentDetails?.isConnected;
  const isAlumniVerificationEnabled = paymentDetails?.alumniVerificationEnabled;

  const currentDate = new Date();
  const MarketingBannerDisplayStartDate = new Date('2024-12-05');
  const MarketingBannerDisplayEndDate = new Date('2024-12-19');
  MarketingBannerDisplayStartDate.setHours(0, 0, 0, 0);
  MarketingBannerDisplayEndDate.setHours(23, 59, 59, 999);

  const tempBannerArray = [];

  if (paymentDetails?.loading) return [];

  // Alumni Verification Banner: P1
  if (!isAlumniVerificationEnabled) {
    tempBannerArray.push('alumniVerification');
  }

  // Slack Connect Banner: P2
  // if (tempBannerArray.length < 2 && !isConnectModelPaused) {
  //   tempBannerArray.push('connect');
  // }

  // Upsell Banner: P3
  if (!isUpsellRecommendationsPaused && isUpsellDataPresent && tempBannerArray.length < 2) {
    tempBannerArray.push('upsell');
  }

  // Refer and Earn Banner: P4
  // Commmented As per Improvement 20836
  // if (isReferralEnabled && tempBannerArray.length < 2) {
  //   tempBannerArray.push('refer');
  // }

  // Marketing Banner
  if (
    currentDate >= MarketingBannerDisplayStartDate &&
    currentDate <= MarketingBannerDisplayEndDate
  ) {
    tempBannerArray.push('marketing');
  }

  // Razorpay Banner: P0, shown for two weeks only
  if (new Date() <= new Date('2024-08-09')) {
    tempBannerArray.unshift('razorpay');
  }

  return tempBannerArray;
};

export const getStartDateValidity = (value) => {
  let result = { error: false, msg: '' };

  if (!moment(value, 'YYYY-MM-DD', true).isValid()) {
    result = {
      error: true,
      msg: value ? 'Please enter a valid date' : ''
    };
  }

  return result;
};

export const getDateValidity = (value) => {
  let result = { error: false, msg: '' };
  if (!value) {
    return result;
  }

  const enteredDate = moment(value).format('YYYY-MM-DD');
  const currentDate = moment().format('YYYY-MM-DD');

  if (enteredDate > currentDate) {
    result = {
      error: true,
      msg: 'Date should not be future date'
    };
  } else if (enteredDate === currentDate) {
    result = {
      error: true,
      msg: 'Date should not be current date'
    };
  } else if (Math.abs(moment(enteredDate).diff(moment(currentDate), 'years')) < 10) {
    result = {
      error: true,
      msg: 'Date should be minimum 10 years old'
    };
  }

  return result;
};

export const readFileAsArrayBuffer = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
  });
};

export const getRefEmpCount = (reference, employment) => {
  const lastNonZeroIndex = Array.isArray(reference)
    ? reference?.reduceRight((acc, curr, index) => {
        return curr != 0 && acc === -1 ? index : acc;
      }, -1)
    : -1;
  const totalEmploymentFromReference = lastNonZeroIndex !== -1 ? lastNonZeroIndex + 1 : 0;
  const totalEmployment = Math.max(employment, totalEmploymentFromReference);
  return totalEmployment;
};

export const convertToTitleCase = (str) =>
  str?.replace(/_/g, ' ')?.replace(/\b\w/g, (c) => c?.toUpperCase());

export function formatDocType(input) {
  if (!input) return '';

  return input.replace(/[\s_]+/g, '').toLowerCase();
}

export const mapCustomizationTypes = (inputData) => {
  const checkStatusesMapping = {
    labels: {},
    colors: {}
  };
  const overallStatusMapping = {
    labels: {},
    colors: {}
  };

  inputData.forEach((item) => {
    if (item.type.includes('CHECK_STATUS')) {
      if (item.type.includes('COLOR')) {
        checkStatusesMapping.colors[item.type] = item.value;
      } else {
        checkStatusesMapping.labels[item.type] = item.value;
      }
    } else if (item.type.includes('OVERALL_STATUS')) {
      if (item.type.includes('COLOR')) {
        overallStatusMapping.colors[item.type] = item.value;
      } else {
        overallStatusMapping.labels[item.type] = item.value;
      }
    }
  });

  return {
    checkStatusesMapping,
    overallStatusMapping
  };
};

export const findEnumValue = (mapping, targetValue) => {
  for (const key in mapping) {
    if (mapping[key] === targetValue) {
      return key;
    }
  }
  return '';
};

export const getCustomMapping = (mapping, status, enumMapping) => {
  if (!mapping || !status) {
    return '';
  }

  const enumValue = findEnumValue(enumMapping, status);
  return mapping[enumValue];
};
